import React from 'react';
import { FaCrown, FaGem, FaStar, FaHandshake } from 'react-icons/fa6';
import { mediaSrc } from '../utils/api';
import './SponsorShowcase.css';

/**
 * Sponsorları kademe hiyerarşisiyle gösteren ortak vitrin.
 * Hem ana sayfada (variant="home") hem sponsorluk sayfasında (variant="page") kullanılır;
 * tek fark logo ölçekleri ve başlık boyutları.
 *
 * Kademe sırası sunucudaki TIERS ile aynı olmalı (server/controllers/sponsorController.js).
 */
export const TIER_CONFIG = [
  { key: 'ana', label: 'Ana Sponsor', Icon: FaCrown },
  { key: 'platin', label: 'Platin Sponsorlarımız', Icon: FaGem },
  { key: 'altin', label: 'Altın Sponsorlarımız', Icon: FaStar },
  { key: 'gumus', label: 'Gümüş Sponsorlarımız', Icon: FaHandshake },
];

const SponsorLogo = ({ sponsor }) => {
  const img = (
    <img
      src={mediaSrc(sponsor.image)}
      alt={`${sponsor.name} logosu`}
      className="sponsor-showcase-logo"
      loading="lazy"
    />
  );

  // Link varsa tıklanabilir olsun; yoksa gereksiz <a> üretme (erişilebilirlik + SEO).
  return (
    <div className="sponsor-showcase-item">
      {sponsor.url ? (
        <a
          href={sponsor.url}
          target="_blank"
          rel="noopener noreferrer"
          className="sponsor-showcase-link"
          title={sponsor.name}
        >
          {img}
        </a>
      ) : (
        <span className="sponsor-showcase-link" title={sponsor.name}>{img}</span>
      )}
    </div>
  );
};

const SponsorShowcase = ({ sponsors = [], variant = 'home', headingLevel = 'h3' }) => {
  const Heading = headingLevel;

  const groups = TIER_CONFIG
    .map((tier) => ({ ...tier, items: sponsors.filter((s) => (s.tier || 'gumus') === tier.key) }))
    .filter((g) => g.items.length > 0);

  if (groups.length === 0) return null;

  return (
    <div className={`sponsor-showcase sponsor-showcase--${variant}`}>
      {groups.map(({ key, label, Icon, items }) => (
        <section key={key} className={`sponsor-tier sponsor-tier--${key}`} aria-label={label}>
          <Heading className="sponsor-tier-title">
            <Icon className="sponsor-tier-icon" aria-hidden="true" />
            <span>{label}</span>
          </Heading>

          {/* Az sponsor varsa ortalanır, çoğalınca yatay kaydırılır:
              dıştaki kutu overflow-x, içteki satır inline-flex → text-align:center ile ortalanıyor. */}
          <div className="sponsor-tier-track">
            <div className="sponsor-tier-row">
              {items.map((s) => <SponsorLogo key={s.id} sponsor={s} />)}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default SponsorShowcase;
